export const headerCopy = {
  description:
    'Tome is designed to surface SLO data grouped by Capabilities. \
    Capabilities can be filtered down based on the operating Team \
    or the Product they belong to. Search queries are additive \
    - additional scopes will increase the number of results.',
  title: 'Catalog',
};
